import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { SessionService, ZeissPanel } from '../../services/session.service';
import { RegionService } from '../../services/region.service';
import { NetworkStatusService } from '../../services/network-status.service';
import { SharedConstants } from '../../services/shared/shared-constants';
import { TrackingService } from '../../services/tracking.service';

@Component({
  selector: 'slide6-page',
  templateUrl: 'slide6.html',
})
export class Slide6Page {
  onlineStatus: boolean;
  constructor(
    private router: Router,
    public regionService: RegionService,
    public sessionService: SessionService,
    public networkService: NetworkStatusService,
    private trackingService: TrackingService
  ) {
    this.networkService.online$.subscribe((res) => {
      this.onlineStatus = res;
    });
  }

  prev(): void {
    this.onlineStatus
      ? this.router.navigate(['issues-experienced'])
      : this.networkService.presentToast(SharedConstants.networkErrorMessage);
    this.trackingService.resetTrackingValues();
  }

  next(): void {
    this.onlineStatus ? this.router.navigate(['recommendation']) : this.networkService.presentToast(SharedConstants.networkErrorMessage);
  }

  selectPanel(panel: ZeissPanel): void {
    console.log('panel', panel);

    panel.selected = !panel.selected;
  }
}



// WEBPACK FOOTER //
// ./src/pages/slide6/slide6.ts